import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { UserService, User, AlertsService, DataService, LoaderService, Facilities } from '../../shared';
import { timer, of, EMPTY } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';
import { VaccineContext } from '../../shared/models/vaccine-context.model';
import { FacilityService } from '../../shared/services/facility.service';
import { Facility } from '../../shared/models/facility.model';
import { Pharmacy } from '../../shared/models/pharmacy.models';
import { PharmacyService } from '../../shared/services/pharmacy.service';
import { MessageBoxService } from '../../shared/services/message-box.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { error } from 'console';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  authForm: UntypedFormGroup;
  facilityControl = new FormControl('', Validators.required);
  isSubmitting = false;
  formloading = false;
  backToSearch: boolean;
  token : string = "";
  showDropdownModal = false;
  facilityOptions = [];
  selectedOption = '';

  constructor(
    private router: Router,
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private alertsService: AlertsService,
    private _dateService: DataService,
    private _facilityService: FacilityService,
    private _pharmacyService: PharmacyService,
    private _msgService: MessageBoxService,
    private loaderService: LoaderService,
    private _navigationService: NavigationService,
    private route: ActivatedRoute,
    private dataService: DataService,
    
  ) {
    this.authForm = this.fb.group({
      facilityRole: [null, Validators.required] 
    });

    this.backToSearch = false;
  }

  closeDropdownModal() {
    this.showDropdownModal = false;
     this.userService.logOff();
  }

  confirmSelection() {
    if (this.authForm.valid) {
      this.submitForm();
      this.showDropdownModal = false;
    } else {
      this.authForm.markAllAsTouched();
      return;
    }
  }

  ngOnInit() {

    this.route.queryParamMap.subscribe(params => {
      const tokenKey = Array.from(params.keys).find(k => k.toLowerCase() === 'token');
      this.token = tokenKey ? params.get(tokenKey) : null;
    });



    this.alertsService.clearLoader();
    /*
      if (localStorage.getItem("HENS3")) {            
          this.router.navigateByUrl('/search');
      } */
    //this.userService.purgeAuthFromLogin();

    //this._dateService.vaccineContext.clearContext();

    this.userService.checkVaccineContextBeforeLogin();

    if (this.dataService.vaccineContext.getContext() == null) {
      this.submitForm();

    }

  }
  onCancel(): void {
    this.userService.logOff();
  }

  submitForm() {

    this.authForm.disable();

    this.isSubmitting = true;

    this.userService.loginWithToken({ Token: this.token, FacilityKey: this.selectedOption }).subscribe((context: VaccineContext) => {
      if (context.facilities.length > 1) {
        this.facilityOptions = context.facilities;
        this.showDropdownModal = true;
        return;
      }
      this._navigationService.navigateToViewType(context);
      this.isSubmitting = false;
    },
      resp => {
        if (resp.error) {
          let msg = 'Your session already expired. Please login to continue';
          if (resp.error?.error) {
            msg = resp.error.error;
          };
          this._msgService.error({
            title: 'Error',
            message: msg
          }).subscribe(_ => {
            this.userService.logOff();
          });
          return EMPTY;

        }
        this.isSubmitting = false;
      },
      () => {
        this.isSubmitting = false;

      });

    //this.isSubmitting = false;
    this.authForm.enable();
  }



  async loginAsFacility() {

    this._dateService.vaccineContext.clearContext();

    const facility = await this._facilityService.selectFacility(101438).toPromise<Facilities>()
    let context: VaccineContext = {
      viewType: 'facility',
      contextFacility: facility,
      //contextUser: {
      //  email: 'facilty@wer.com',
      //  firstName: 'robert',
      //  lastName: 'dsuza',
      //  institutionId: '232323',
      //  userName: 'rdsuze',
      //  userType: 'facilityuser'
      //}
    };

    this._dateService.vaccineContext.setContext(context);

    //this.router.navigate(['vaccine-schedule/facility']);
    this.router.navigate(['covid-lite-home']);

  }

  async loginAsPharmacy() {

    this._dateService.vaccineContext.clearContext();
    const pharmacy = await this._pharmacyService.getPharmacy(101).toPromise<Pharmacy>();
    let context: VaccineContext = {
      viewType: 'pharmacy',
      contextPharmacy: pharmacy,
      //contextUser: {
      //  email: 'pharmacy@wer.com',
      //  firstName: 'julia',
      //  lastName: 'robers',
      //  institutionId: '232323',
      //  userName: 'jroberts',
      //  userType: 'pharmacyUser'
      //}
    };

    this._dateService.vaccineContext.setContext(context);
    //'covid-lite-home'
    //this.router.navigate(['vaccine-schedule/pharmacy']);
    this.router.navigate(['covid-lite-home']);

  }

  async LoginAsAdmin() {

    this._dateService.vaccineContext.clearContext();
    let context: VaccineContext = {
      viewType: 'admin',
      //contextUser: {
      //  email: 'admin@oda.com',
      //  firstName: 'will',
      //  lastName: 'smith',
      //  institutionId: '232323',
      //  userName: 'wsmith',
      //  userType: 'adminUser'
      //}
    };

    this._dateService.vaccineContext.setContext(context);

    //this.router.navigate(['vaccine-schedule/admin']);
    this.router.navigate(['covid-lite-home']);

  }  

}
